module.exports = __webpack_public_path__ + "img/home_k.85b38214.png";